import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {delay, first, takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {SoldPolicyService} from '../../../shared/services/sold-policy.service';
import {Partner} from '../../../shared/interface/partner';
import {MatDialog} from '@angular/material/dialog';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {

  soldPolicyReportFormValid = false;
  soldPolicyReportForm: FormGroup;
  companyControl: FormControl;
  insuranceCompanyControl: FormControl;
  regionalControl: FormControl;
  partnerControl: FormControl;
  facilityControl: FormControl;
  ofwcaControl: FormControl;
  concludeDateFromControl: FormControl;
  concludeDateToControl: FormControl;
  groupingControl: FormControl;
  historicalStructureControl: FormControl;
  processingRequest = false;
  formErrors = {};
  selectedPartners: Partner[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private soldPolicyService: SoldPolicyService,
    private dialog: MatDialog,
  ) {
    this.soldPolicyReportForm = fb.group({
      company: this.companyControl = fb.control([], []),
      insuranceCompany: this.insuranceCompanyControl = fb.control([], []),
      regional: this.regionalControl = fb.control([], []),
      partner: this.partnerControl = fb.control([], []),
      facility: this.facilityControl = fb.control([], []),
      ofwca: this.ofwcaControl = fb.control([], []),
      concludeDateFrom: this.concludeDateFromControl = fb.control('', [Validators.required]),
      concludeDateTo: this.concludeDateToControl = fb.control('', [Validators.required]),
      grouping: this.groupingControl = fb.control([], [Validators.required]),
      historicalStructure: this.historicalStructureControl = fb.control(true, []),
    });
  }

  ngOnInit(): void {
    this.soldPolicyReportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.soldPolicyReportFormValid = this.soldPolicyReportForm.valid;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  createReport(): void {
    if (!this.soldPolicyReportForm.valid) {
      this.soldPolicyReportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.soldPolicyReportForm, this.formErrors);
    this.formErrors = {};

    this.soldPolicyService.createReport(this.soldPolicyReportForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas tworzenia raportu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.soldPolicyReportForm, this.formErrors);
        }
      })
    ;
  }

  onPartnerSelect(partners: Partner[]): void {
    this.selectedPartners = partners;
  }
}
